import { createSagaMiddleware } from 'async-saga';
import { routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import { LocationState } from '.';
import * as actions from './actions';
import rootHandler from './async-saga';
import { createRootReducer } from './reducers';
import { RootState } from './types';
import { composeEnhancers } from './utils';
export { actions };



const loggerMiddleware = createLogger();

const sagasMiddleware = createSagaMiddleware(rootHandler)


export function configureStore(initialState: Partial<RootState>, history: History<LocationState>) {

  const middlewares = [sagasMiddleware, loggerMiddleware, routerMiddleware(history)];
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));
  const store = createStore(createRootReducer<LocationState>(history), initialState!, enhancer);

  sagasMiddleware.run();

  return store;
}
